import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTranslation } from "react-i18next";

// Web hailing's copy of the web receipt's driver card (web-receipt/DriverCard), with the
// ride class beside the plate. A copy, so receipt changes do not reach the tracker.
export interface TripDriverCardProps {
  licensePlate: string;
  carMake: string;
  carModel: string;
  driverName: string;
  driverPhone: string;
  carImageUrl?: string;
  /** e.g. "Luxury · Meter". */
  vehicleClassLabel?: string;
}

const TripDriverCard: React.FC<TripDriverCardProps> = ({
  licensePlate,
  carMake,
  carModel,
  driverName,
  driverPhone,
  carImageUrl = "",
  vehicleClassLabel,
}) => {
  const { t } = useTranslation("hailing");
  return (
    <div className="w-full flex flex-col items-stretch">
      <div className="rounded-lg p-4 flex flex-col gap-2 mx-5 mt-2 mb-2 max-w-full bg-white">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex flex-wrap items-center gap-x-2 mb-2">
              <div className="text-base inline-block bg-nobel-50 rounded-lg px-2 py-1 font-bold text-mineshaft-900">
                {licensePlate}
              </div>
              {vehicleClassLabel && (
                <span className="text-sm font-semibold text-mineshaft-700">
                  {vehicleClassLabel}
                </span>
              )}
            </div>
            {(carMake || carModel) && (
              <div className="text-base font-bold text-mineshaft-900">
                {[carMake, carModel].filter(Boolean).join(" ")}
              </div>
            )}
            <div className="text-base font-semibold text-mineshaft-900">
              {driverName}
              {driverPhone
                ? ` • ${driverPhone.replace(/^(\+852)(\d+)/, "$1 $2")}`
                : ""}
            </div>
          </div>
          {carImageUrl && (
            <img
              src={carImageUrl}
              alt=""
              className="w-20 h-20 object-contain mr-4"
              style={{ transform: "scaleX(-1)" }}
            />
          )}
        </div>
        {driverPhone && (
          <a
            href={`tel:${driverPhone.replace(/\s/g, "")}`}
            className="flex items-center justify-center gap-2 rounded-full py-2 px-4 font-semibold text-base transition bg-brand-blue-light text-brand-blue"
            style={{ textDecoration: "none" }}
          >
            <PhoneIcon sx={{ fontSize: 20 }} className="text-brand-blue" />
            {t("steps.ride.tracker.commonCallDriverButton")}
          </a>
        )}
      </div>
    </div>
  );
};

export default TripDriverCard;
